import { ColumnTypeEnum, GbTableColumn } from '@galabid/gb-dashboard/shared/feature'

export const initialDisplayColumns: GbTableColumn[] = [
  {
    columnKey: 'purchaser_name',
    columnLabel: 'EVENT_TICKET_PURCHASES.PURCHASER',
    columnType: ColumnTypeEnum.Label,
  },
  {
    columnKey: 'ticket_package_name',
    columnLabel: 'EVENT_TICKET_PURCHASES.TICKET_NAME',
    columnType: ColumnTypeEnum.Link,
  },
  {
    columnKey: 'quantity',
    columnLabel: 'EVENT_TICKET_PURCHASES.QUANTITY',
    columnType: ColumnTypeEnum.Label,
  },
  {
    columnKey: 'total',
    columnLabel: 'EVENT_TICKET_PURCHASES.TOTAL',
    columnType: ColumnTypeEnum.Currency,
  },
  {
    columnKey: 'created',
    columnLabel: 'EVENT_TICKET_PURCHASES.PURCHASE_DATE',
    columnType: ColumnTypeEnum.Date,
    dateFormat: 'MMM d, y, h:mm:ss a',
  },
  {
    columnKey: 'refunded_quantity',
    columnLabel: 'EVENT_TICKET_PURCHASES.REFUNDED_QTY',
    columnType: ColumnTypeEnum.Label,
  },
  {
    columnKey: 'paid',
    columnLabel: 'EVENT_TICKET_PURCHASES.PAYMENT_STATUS',
    columnType: ColumnTypeEnum.Template,
  },
  {
    columnKey: 'payment_method',
    columnLabel: 'EVENT_TICKET_PURCHASES.PAYMENT_METHOD',
    columnType: ColumnTypeEnum.Label,
  },
  {
    columnKey: 'actions',
    columnLabel: 'EVENT_TICKET_PURCHASES.ACTIONS',
    columnType: ColumnTypeEnum.Actions,
  },
]
export const additionalDisplayColumns: GbTableColumn[] = [
  {
    columnKey: 'refund_date',
    columnLabel: 'EVENT_TICKET_PURCHASES.REFUND_DATE',
    columnType: ColumnTypeEnum.Date,
  },
]
